import classNames from "classnames";
import { FC, useRef } from "react";

import Button, { ButtonProps } from "~/components/Button/Button";
import Icon from "~/components/Icon";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import useClickOutside from "~/hooks/useClickOutside";
import CheckoutSummary from "../CheckoutSummary";
import styles from "./CheckoutSummaryDrawer.module.scss";

interface CheckoutSummaryDrawerProps {
  onClose?: () => void;
  okText?: string;
  okProps?: ButtonProps;
  className?: string;
  open?: boolean;
}

const CheckoutSummaryDrawer: FC<CheckoutSummaryDrawerProps> = ({
  onClose,
  okText = "Proceed to checkout",
  okProps,
  className,
  open,
}) => {
  const CheckoutSummaryDrawerRef = useRef(null);

  const close = () => {
    onClose?.();
  };

  // useClickOutside(CheckoutSummaryDrawerRef, close);

  return (
    <div
      className={classNames(styles.checkout_summary_drawer, {
        [styles.open]: open,
      })}
    >
      <div
        className={classNames(styles.container, className)}
        ref={CheckoutSummaryDrawerRef}
      >
        <div className={styles.title}>
          <Text type="title-3" color={Colors.GREY_800}>
            Summary
          </Text>
          <Icon
            name="close"
            color={Colors.GREY_800}
            onClick={close}
            className="cursor-pointer"
          />
        </div>
        <div className="mb-4">
        <CheckoutSummary />
        </div>
        {/* <Button
          {...okProps}
          className={classNames("mx-4 mb-5", okProps?.className)}
        >
          {okText}
        </Button> */}
      </div>
    </div>
  );
};

export default CheckoutSummaryDrawer;
